import { Navigate, Outlet } from 'react-router-dom';
import { useProductsContext } from '../../context/ProductsContext';

export default function CalculatorRoute() {
  const { isCalculator } = useProductsContext();

  if (isCalculator) {
    return <Navigate to="/tasks" replace />;
  }

  return <Outlet />;
}
